export default interface ICleaningSchedule {
    id: number;
    localId: number;
    monday: number;
    tuesday: number;
    wednesday: number;
    thursday: number;
    friday: number;
    saturday: number;
    sunday: number;
}
export const defaultCleaningSchedule: ICleaningSchedule = {
    id: 0,
    localId: 0,
    monday: 0,
    tuesday: 0,
    wednesday: 0,
    thursday: 0,
    friday: 0,
    saturday: 0,
    sunday: 0,
};

type ScheduleKey = keyof ICleaningSchedule;

export const dayNames = new Map<number, ScheduleKey>([
    [0, "sunday"],
    [1, "monday"],
    [2, "tuesday"],
    [3, "wednesday"],
    [4, "thursday"],
    [5, "friday"],
    [6, "saturday"],
]);
